// frontend/src/config/apiConfig.ts

const API_BASE_URL = import.meta.env.VITE_API_BASE_URL;

if (!API_BASE_URL) {
  console.error(
    "CRITICAL FRONTEND CONFIG ERROR: VITE_API_BASE_URL is not defined. " +
    "This means your frontend cannot determine which backend API to connect to. " +
    "Troubleshooting Steps: " +
    "1. Development: Ensure `frontend/.env.development` exists and contains `VITE_API_BASE_URL=your_local_backend_url`. " +
    "2. Production Build: Ensure `frontend/.env.production` exists (if building locally for prod) OR that `VITE_API_BASE_URL` is set as an environment variable in your deployment platform (e.g., Render). " +
    "3. Ensure you have restarted your Vite development server after creating/modifying .env files. " +
    "4. Double-check the variable name is exactly VITE_API_BASE_URL (case-sensitive and must start with VITE_)."
  );
  // Consider throwing an error here in development to make it more obvious
  // throw new Error("VITE_API_BASE_URL is not defined. See console for details.");
} else {
  // This log helps confirm which URL is being used at runtime.
  console.log("[apiConfig.ts] API Base URL Initialized For Frontend:", API_BASE_URL);
}

export { API_BASE_URL };